import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import NoItemResult from '../../../components/results/NoItemResult';
import { useAddPermissionDrawer } from './RoleAddPermissionDrawer';

export type RolePermissionEmptyListProps = { role: RoleSpecsFragment };

const RolePermissionEmptyList = ({ role }: RolePermissionEmptyListProps) => {
    const { t } = useTranslation(['roleDetails']);
    const addPermissionDrawer = useAddPermissionDrawer(role);

    return (
        <NoItemResult
            extra={
                <>
                    <Button onClick={addPermissionDrawer.open} type="primary">
                        {t('roleDetails:tabs.permissions.noData.action')}
                    </Button>
                    {addPermissionDrawer.render()}
                </>
            }
            subTitle={t('roleDetails:tabs.permissions.noData.message')}
        />
    );
};

export default RolePermissionEmptyList;
